import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, FormControlLabel, Grid, Radio } from "@mui/material";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { ProgressBar } from "../../../_uiComponents/Onboarding/ProgressBar";
import { addProfileDataRequest } from "../../../../_redux/_actions/onboarding.actions";
import { clearCommonErrors } from "../../../../_redux/_actions";
import {
  commonConstants,
  onboardingConstants,
  responseCodes,
} from "../../../../_redux/_constants";
import Validator from "../../../../_helpers/validate.schema";
import UiInput from "../../../_uiComponents/UiInput";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { getFingerPrint } from "../../../../_helpers/support.services";

export const NewDisplayNameForm = (props) => {
  const {
    ownFormData: ownFormData,
    otpConfirmationData: otpConfirmationData,
    addProfileData: addProfileData,
  } = useSelector((state) => state.onboarding);
  const errorMessage = useSelector((state) => state.errorMessage);

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const validateSchema = () =>
    yup.object().shape({
      displayName: yup
        .string()
        .matches(
          /^[a-zA-Z0-9](?:[a-zA-Z0-9 ]*[a-zA-Z0-9])?$/,
          "Only one space is allowed, not at the beginning or end. Letters and numbers only.",
        )
        .min(3, "Dispaly nmae must be at least 6 characters")
        .required(t("This field is required")),
    });

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };

  const goBack = () => {
    dispatch(clearCommonErrors());
    props?.changeFlowStep(onboardingConstants.ONBOARDING_PASSWORD_STEP);
  };

  const submitData = async (param) => {
    const password = props?.getEphemeralPassword?.();
    if (!password) {
      props?.changeFlowStep(onboardingConstants.ONBOARDING_PASSWORD_STEP);
      return;
    }

    const fingerPrint = await getFingerPrint();
    let payload = {
      locale: i18n.language,

      deviceType: commonConstants.DEVICE_TYPE_WEB,

      uid: fingerPrint,

      username: ownFormData?.username,

      nickname: param.displayName,

      password,

      confirmPassword: password,

      customerSubProfileAvailable:
        otpConfirmationData?.customerSubProfileAvailable,
    };

    dispatch(addProfileDataRequest(payload));
  };

  useEffect(() => {
    if (errorMessage?.customErrors.length > 0) {
      var status = errorMessage?.customErrors[0];

      if (status.statusCode) {
        props?.changeFlowStep(onboardingConstants.PROCESS_UNSUCCESSFUL_STEP);
      }
    }
  }, [errorMessage]);

  useEffect(() => {
    if (addProfileData?.responseCode) {
      if (addProfileData?.responseCode == responseCodes.SUCCESS_CODE) {
        props?.clearEphemeralPassword?.();
        props?.changeFlowStep(onboardingConstants.PROCESS_SUCCESSFUL_STEP);
      } else {
        props?.clearEphemeralPassword?.();
        props?.changeFlowStep(onboardingConstants.PROCESS_UNSUCCESSFUL_STEP);
      }
    }
  }, [addProfileData]);
  return (
    <>
      <div className="df-user-profile df-reset-cd-form df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon"
            onClick={props?.closeBtn}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <ProgressBar
              noOfActive={6}
              total={
                ownFormData?.registrationType ==
                onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT
                  ? 7
                  : 6
              }
            />

            <BackIcon onClick={goBack} />
          </div>

          <div className="df-user-profile__body df-pw-tab df-card-details-tb">
            <Grid container>
              <Grid size={12} className="text-left df-pl-2">
                <div className="df-onboard-complete-wr">
                  <h2 className="df-reset-pw-title">
                    {t(
                      "Almost there! Please enter a name for your digital banking profile."
                    )}
                  </h2>

                  <Form
                    onSubmit={submitData}
                    validate={onValidate}
                    render={({
                      handleSubmit,
                      values,
                      submitting,
                      error,
                      hasValidationErrors,
                      form,
                    }) => {
                      const isFormValid = !hasValidationErrors;

                      const { dirty } = form.getState();

                      return (
                        <>
                          <div className="df-onboard-inputs">
                            <UiInput
                              name="displayName"
                              id="displayName"
                              label={t("Name") + " *"}
                              type="text"
                              min={0}
                              value={values?.displayName}
                              inputonChange={(e) => {
                                const input = e.target.value;
                                const cleaned = input
                                  .replace(/[^a-zA-Z ]/g, "") // Only letters and spaces allowed
                                  .replace(/^\s+/g, "");
                                const value =
                                  cleaned.charAt(0).toUpperCase() +
                                  cleaned.slice(1);
                                form.change("displayName", value);
                              }}
                              clearable={true}
                              minLength={3}
                              maxLength={15}
                              form={form}
                            />
                          </div>

                          <UiButton
                            onClick={handleSubmit}
                            className="df-ui-dark-bg-btn w-100 mt-2 df-onboard-radio-btn df-new-display-name-form-btn"
                            name={t("Complete")}
                            disabled={!isFormValid}
                          />
                        </>
                      );
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
